import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Css/NotFound.css";

const NotFound = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Page Not Found | SportsForEquity";

    let robotsMeta = document.querySelector('meta[name="robots"]');
    let createdMeta = false;
    const prevContent = robotsMeta ? robotsMeta.getAttribute("content") : null;

    if (!robotsMeta) {
      robotsMeta = document.createElement("meta");
      robotsMeta.setAttribute("name", "robots");
      document.head.appendChild(robotsMeta);
      createdMeta = true;
    }
    robotsMeta.setAttribute("content", "noindex, nofollow");

    return () => {
      document.title = prevTitle;
      if (createdMeta) {
        robotsMeta.remove();
      } else if (prevContent !== null) {
        robotsMeta.setAttribute("content", prevContent);
      }
    };
  }, []);

  return (
    <div className="notfound-wrapper">
      <div className="notfound-code">404</div>
      <h1 className="notfound-title">Page Not Found</h1>
      <p className="notfound-text">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link to="/" className="notfound-btn">
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
